import SelectCompanyFromList from "company/selectFromList/app";
import { Modal } from "components";
import { Message } from "semantic-ui-react";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  isOpen: boolean
  onClose: () => void
  webformId?: number
  companyId: number
  companyName: string
}

const CompanyMergeModal = ({ isOpen, webformId, companyId, companyName, onClose }: Props) => {
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

  const onCompanySelected = async (company: server.dto.CompanySmall) => {
    const canMerge = await window.CoreApi.Company.AllowMerge({
      sourceCompanyId: companyId,
      targetCompanyId: company.companyId
    });

    if (canMerge.data.hasErrors) {
      setErrorMessage(`${RESX.GeneralWarnings.YouCannotMerge}: ${canMerge.data.errors[0].message}`);
      return;
    }

    setErrorMessage(null);
    if (webformId) {
      window.location.href = `${routes.company_Merge(companyId, company.companyId).absolute}?fromWebformId=${webformId}`;
    } else {
      window.location.href = routes.company_Merge(companyId, company.companyId).absolute;
    }
    onClose();
  }

  return <>
    <Modal
      isOpen={isOpen}
      title={RESX.OptionsPanel.Merge}
      handleClose={onClose}
      width="small"
      height={700}
    >
      <SelectCompanyFromList
        onCompanySelected={onCompanySelected}
        initialInstruction={{
          keyword: companyName,
          excludeKeys: [companyId]
        }}
      />
      {errorMessage && <div>
        <Message color="red">
          {errorMessage}
        </Message>
      </div>}
    </Modal>
  </>;
};

export default CompanyMergeModal;